module.exports = __webpack_public_path__ + "static/assets/2ac565c5591f56749288eb8685f50828.png";